module.exports = __webpack_public_path__ + "img/help.13bd9d88.svg";